import React from 'react'
import {graphql} from 'gatsby'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import Button from '../Button/Button'
import './Intro.scss'

export default function Intro({title, button, image}) {
	return(
		<div className="Intro">
			<div className="content">
				<div className="inner">
					{ title ? <h1 dangerouslySetInnerHTML={{__html: title}} /> : null }
					{ button ? <Button {...button} color="primary" /> : null }
				</div>
			</div>
			<div className="image">
				{ image ? <GatsbyImage image={getImage(image.localFile.childImageSharp)} alt="" /> : null }
			</div>
		</div>
	)
}

export const query = graphql`
	fragment Intro on WpPage_Layout_block_Layout_Intro {
		fieldGroupName
		title
		button {
			url
			title
			target
		}
		image {
			altText
			localFile {
				childImageSharp {
					gatsbyImageData(
						width: 2000,
						height: 1000,
						quality: 80,
						placeholder: DOMINANT_COLOR,
						transformOptions: {cropFocus: NORTH}
					)
				}
			}
		}
	}
`